import { render, staticRenderFns } from "./FDProduct.vue?vue&type=template&id=53107012&"
import script from "./FDProduct.vue?vue&type=script&lang=js&"
export * from "./FDProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports